// JsFromRoutes CacheKey 5b959fb532cc7126b53a8bde706ce0d4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/storage/direct_uploads'),
}
